import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
var ProtectedRoute = function (_a) {
    var children = _a.children;
    var _b = useAuthStore(), isAuthenticated = _b.isAuthenticated, loading = _b.loading;
    if (loading)
        return _jsx("p", { children: "Cargando..." });
    return isAuthenticated ? _jsx(_Fragment, { children: children }) : _jsx(Navigate, { to: "/login" });
};
export default ProtectedRoute;
